import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    SUBMIT_FIRM_APPLICATION,
    submitFirmApplicationSuccessful,
    FETCH_FIRM_APPLICATION,
    fetchFirmApplicationReceived,
    UPDATE_FIRM_APPLICATION,
    firmApplicantUpdated,
    FETCH_FIRM_APPLICATION_STATUS,
    startLoading,
    stopLoading
} from '../actions'

import {
    SUBMIT_FIRM_APPLICATION_ID,
    FETCH_FIRM_APPLICATION_STATUS_ID
} from '../store/loaders'



function * submitFirmApplication (payload){
    yield put(startLoading({id:SUBMIT_FIRM_APPLICATION_ID}))

    try{
       const response=  yield call(DCore.post, '/applications/firms',{...payload.data.data})
       yield put(stopLoading({id:SUBMIT_FIRM_APPLICATION_ID}))
        yield put (submitFirmApplicationSuccessful(response.data))
        yield put (firmApplicantUpdated(payload.data.reqId))
    }catch(e){
       yield put(stopLoading({id:SUBMIT_FIRM_APPLICATION_ID}))
        console.log("some thing went wrong", e)
    }
}

function * updateFirmApplication (paylaod){
    yield put(startLoading({id:SUBMIT_FIRM_APPLICATION_ID}))
    try{
       const response=  yield call(DCore.put, `/applications/firms/${paylaod.data.id}`,{...paylaod.data.data})
       yield put(stopLoading({id:SUBMIT_FIRM_APPLICATION_ID}))
       yield put (submitFirmApplicationSuccessful(response.data))
        yield put (firmApplicantUpdated(paylaod.data.reqId))

    }catch(e){
       yield put(stopLoading({id:SUBMIT_FIRM_APPLICATION_ID}))
        console.log("some thing went wrong", e)
    }
}

function * fetchFirmApplication (payload){
    try{
       const response=  yield call(DCore.get, `/applications/${payload.data}/firm`)
        yield put (fetchFirmApplicationReceived(response.data))
    }catch(e){
        console.log("some thing went wrong", e)
    }
}

function * fetchFirmApplicationStatus (payload){
    yield put(startLoading({id:FETCH_FIRM_APPLICATION_STATUS_ID}))
    try{
       const response=  yield call(DCore.get, `/applications/${payload.data}/firms`)
        yield put(stopLoading({id:FETCH_FIRM_APPLICATION_STATUS_ID}))
        yield put (fetchFirmApplicationReceived(response.data))
    }catch(e){
        yield put(stopLoading({id:FETCH_FIRM_APPLICATION_STATUS_ID}))
        console.log("some thing went wrong", e)
    }
}


export function * firmApplicationSaga(){
    yield takeLatest(SUBMIT_FIRM_APPLICATION,submitFirmApplication)
    yield takeLatest(FETCH_FIRM_APPLICATION,fetchFirmApplication)
    yield takeLatest(UPDATE_FIRM_APPLICATION,updateFirmApplication)
    yield takeLatest(FETCH_FIRM_APPLICATION_STATUS,fetchFirmApplicationStatus)


}